import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=8c5ff95a&"
import script from "./fileUpload.vue?vue&type=script&lang=js&"
export * from "./fileUpload.vue?vue&type=script&lang=js&"
import style0 from "./fileUpload.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c5ff95a')) {
      api.createRecord('8c5ff95a', component.options)
    } else {
      api.reload('8c5ff95a', component.options)
    }
    module.hot.accept("./fileUpload.vue?vue&type=template&id=8c5ff95a&", function () {
      api.rerender('8c5ff95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/fileUpload.vue"
export default component.exports